import styled from 'styled-components'

import { media } from 'src/styles/media'

export const BOTTOM_TOOLBAR_HEIGHT = 8.8

export const Wrap = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  height: ${BOTTOM_TOOLBAR_HEIGHT}rem;
  padding: 0 2.4rem;
  box-shadow: inset 0 0.1rem 0 0 #eeebeb;
  background-image: linear-gradient(238deg, #fffdee 100%, #fef7e2);

  ${media.desktop} {
    padding: 0 3.2rem;
  }
`

export const InnerWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  ${media.desktop} {
    width: 48rem;
  }
`
